const digest = 'a16ca9118663fe77b925b2ac7df536bf5813d8cdd621fca67df51223756c4cb2';
const css = `._collectionLogo_9r4qr_1{align-self:center;height:auto;margin-bottom:2.5rem;max-width:256px}._searchWrapper_9r4qr_8{background-color:#fff;border-left:1px solid #ecedee;border-radius:8px 8px 0 0;border-right:1px solid #ecedee;border-top:1px solid #ecedee;box-sizing:border-box;padding:1.1875rem 1.5rem 1.5rem;width:100%}@media (max-width:768px){._searchWrapper_9r4qr_8{padding:.6875rem 1rem 1rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'collectionLogo': '_collectionLogo_9r4qr_1', 'searchWrapper': '_searchWrapper_9r4qr_8' };
export const collectionLogo = '_collectionLogo_9r4qr_1';
export const searchWrapper = '_searchWrapper_9r4qr_8';
export { css, digest };